import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'

import searchApi from '../../search/api'

const useContactable = (companyIds: number[]) => {
  const { data: contactedMap } = useQuery({
    queryKey: [searchApi.fetchIsContactable.key, companyIds],
    queryFn: () => searchApi.fetchIsContactable.fn(companyIds),
    enabled: !!companyIds?.length,
  })

  const result = useMemo(() => contactedMap ?? {}, [contactedMap])

  return result
}

export default useContactable
